<template>
    <v-card class="wrapper">

        <v-progress-linear class="progress"
                           background-color="grey darken-3"
                           :indeterminate="projectGeoStatsLoading"
                           :value="projectGeoStatsLoading ? null : 0"
        ></v-progress-linear>

        <div id="map" class="mapboxgl-map map"></div>

        <div class="floatingMenu">
            <v-container>
                <v-row dense>
                    <v-col cols="8">
                        <v-select
                                v-model="mapModel"
                                :items="mapItems"
                                label="Solo field"
                                item-text="name"
                                return-object
                                solo
                                background-color="grey darken-2"
                                @change="mapSelected"
                        ></v-select>
                    </v-col>

                    <v-col cols="4">
                        <v-btn-toggle v-model="mapTypeModel" @change="mapTypeChanged">
                            <v-btn>
                                Heatmap
                            </v-btn>

                            <v-btn>
                                Clusters
                            </v-btn>

                        </v-btn-toggle>
                    </v-col>

                </v-row>
            </v-container>
        </div>

<!--        <v-fab-transition>-->
<!--            <v-btn-->
<!--                    color="red"-->
<!--                    dark-->
<!--                    absolute-->
<!--                    top-->
<!--                    right-->
<!--                    small-->
<!--                    fab-->
<!--                    style="margin-top: 40px"-->
<!--                    class="ml-5"-->
<!--                    @click="close"-->
<!--            >-->
<!--                <v-tooltip left color="primary">-->
<!--                    <template v-slot:activator="{ on }">-->
<!--                        <v-icon v-on="on">mdi-close</v-icon>-->
<!--                    </template>-->
<!--                    <span>Close</span>-->
<!--                </v-tooltip>-->
<!--            </v-btn>-->
<!--        </v-fab-transition>-->

        <v-fab-transition>
            <v-btn
                    color="primary"
                    dark
                    absolute
                    top
                    left
                    small
                    fab
                    style="margin-top: 40px"
                    class="mr-5"
                    @click="loadData(true)"
            >
                <v-tooltip right color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon class="ml-1" v-on="on">mdi-reload</v-icon>
                    </template>
                    <span>Reload</span>
                </v-tooltip>
            </v-btn>
        </v-fab-transition>

<!--        <v-fab-transition>-->
<!--            <v-btn-->
<!--                    color="grey lighten-2"-->
<!--                    dark-->
<!--                    absolute-->
<!--                    top-->
<!--                    right-->
<!--                    icon-->
<!--                    style="margin-top: 60px"-->
<!--                    class="ml-1 mr-1"-->
<!--                    @click="helpClicked"-->
<!--            >-->
<!--                <v-tooltip left color="primary">-->
<!--                    <template v-slot:activator="{ on }">-->
<!--                        <v-icon v-on="on" large>mdi-information-outline</v-icon>-->
<!--                    </template>-->
<!--                    <span>Show me what all this means</span>-->
<!--                </v-tooltip>-->
<!--            </v-btn>-->
<!--        </v-fab-transition>-->

        <v-fab-transition>
            <v-btn
                    v-if="hasRole('Super Admin')"
                    color="grey lighten-2"
                    dark
                    absolute
                    right
                    bottom
                    icon
                    style="margin-bottom: 60px"
                    class="ml-1 mr-1"
                    @click="logMapPosition"
            >
                <v-tooltip left color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" large>mdi-map-marker</v-icon>
                    </template>
                    <span>Log current location, pitch, bearing and zoom level to the console</span>
                </v-tooltip>
            </v-btn>
        </v-fab-transition>

        <v-fab-transition>
            <v-btn
                    color="grey lighten-2"
                    dark
                    absolute
                    right
                    bottom
                    icon
                    style="margin-bottom: 10px"
                    class="ml-1 mr-1"
                    @click="setDefaultMapView"
            >
                <v-tooltip left color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" large>mdi-crosshairs-gps</v-icon>
                    </template>
                    <span>Set this map view as my default</span>
                </v-tooltip>
            </v-btn>
        </v-fab-transition>

        <stat-box-numerical class="floatingCompletesBox"
                            :value="project.completed_count"
                            hint="# Completed locations"
                            color="rgba(50,158,244,0.5)"
        ></stat-box-numerical>

        <help v-if="helpDialogModel"
              v-model="helpDialogModel"
              identifier="project-geo-stats"
        ></help>

    </v-card>
</template>

<script>

import {mapActions, mapState} from 'vuex';
import Help from '../../../Help/components';
import MaxBoxGL from 'mapbox-gl';
import StatBoxNumerical from "../../../../components/UI/StatBoxNumerical";

export default {

    components: {
        StatBoxNumerical,
        Help
    },

    props: {
        project: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            mapTypeModel: 0,
            geoStats: null,
            mapItems: [
                {
                    name: "Western hemisphere",
                    data: "countries",
                    import: "mapWorld",
                    zoom: 2.4203077028197653,
                    coordinates: {
                        lng: -36.958670293544486,
                        lat: 33.03762402161614,
                    },
                    bearing: 0,
                    pitch: 0,
                    spin: false,
                },
                {
                    name: "United States",
                    data: "regions",
                    import: "mapUsa",
                    zoom: 4,
                    coordinates: {
                        lng: -98.5795,
                        lat: 39.828175,
                    },
                    bearing: 0,
                    pitch: 0,
                    spin: false,
                },
                {
                    name: "Europe",
                    data: "regions",
                    import: "mapWorld",
                    zoom: 3.6705711337093927,
                    coordinates: {
                        lng: 16.992687275559348,
                        lat: 52.03230699468648
                    },
                    bearing: 0,
                    pitch: 0,
                    spin: false,
                },
                {
                    name: "Asia",
                    data: "regions",
                    import: "mapWorld",
                    zoom: 2.4767441599258806,
                    coordinates: {
                        lng: 124.51727963661835,
                        lat: -1.0841237803618071,
                    },
                    bearing: 0,
                    pitch: 0,
                    spin: false,
                },
                {
                    name: "South America",
                    data: "regions",
                    import: "mapWorld",
                    zoom: 2.763901678466364,
                    coordinates: {
                        lng: -57.932658463960664,
                        lat: -24.744666537370463,
                    },
                    bearing: 0,
                    pitch: 0,
                    spin: false,
                },
                {
                    name: "Central America",
                    data: "regions",
                    import: "mapWorld",
                    zoom: 4.064811608490024,
                    coordinates: {
                        lng: -77.37726507811188,
                        lat: 15.68317909034107,
                    },
                    bearing: 0,
                    pitch: 0,
                    spin: false,
                },
                {
                    name: "Austin, TX",
                    data: "regions",
                    import: "mapWorld",
                    zoom: 16.39,
                    coordinates: {
                        lng: -97.746558,
                        lat: 30.261923
                    },
                    bearing: 0,
                    pitch: 60,
                    spin: true,
                },
                {
                    name: "London, UK",
                    data: "regions",
                    import: "mapWorld",
                    zoom: 15,
                    coordinates: {
                        lng: -0.118092,
                        lat: 51.509865,
                    },
                    bearing: 0,
                    pitch: 60,
                    spin: true,
                }
            ],
            mapModel: null,
            helpDialogModel: false,
            sourceAdded: false,
            flying: false,
        }
    },

    computed: {

        ...mapState('ProjectManager', [
            'projectGeoStats',
            'projectGeoStatsLoading',
        ]),
    },

    created() {
        // Create non reactive map for better performance
        this.map = null;
    },

    mounted() {

        this.mapModel = this.mapItems[0];
        let defaults = this.mapItems[0];

        const storedItem = localStorage.getItem('dashboardMapDefaults');

        if (storedItem) {
            defaults = JSON.parse(storedItem);

            this.mapItems.push(Object.assign({
                name: "My saved view",
                data: "countries",
                import: "mapWorld",
                spin: false,
            }, defaults));

            this.mapModel = this.mapItems[this.mapItems.length - 1];
        }

        MaxBoxGL.accessToken = 'pk.eyJ1IjoianVoYXNldiIsImEiOiJja2ltaTlqcW8wdG80MnlwN2dpczJibW1sIn0.tqKs4UUv6iloR9PuPwNGYA';

        this.map = new MaxBoxGL.Map({
            container: 'map',
            style: 'mapbox://styles/juhasev/ckimr55eg19zw17pg9h77i34s',
            center: [defaults.coordinates.lng, defaults.coordinates.lat],
            zoom: defaults.zoom,
            pitch: defaults.pitch,
            bearing: defaults.bearing,
            maxZoom: 19,
            minZoom: 1.6161262730143358,
            attributionControl: false,
            interactive: true,
        });

        this.map.on('load', () => {
            this.loadData();

            this.map.loadImage(
                    this.cdnBaseUrl('img/marker.png'),
                    (error, image) => {
                        if (error) throw error;
                        this.map.addImage('marker', image);
                    })


            this.map.resize();
        });
    },

    methods: {

        ...mapActions('ProjectManager', [
            'getProjectGeoStats'
        ]),

        helpClicked() {
            this.helpDialogModel = true;
        },

        logMapPosition() {
            console.log({
                zoom: this.map.getZoom(),
                coordinates: this.map.getCenter(),
                pitch: this.map.getPitch(),
                bearing: this.map.getBearing()
            });
        },

        setDefaultMapView() {

            const data = {
                zoom: this.map.getZoom(),
                coordinates: this.map.getCenter(),
                pitch: this.map.getPitch(),
                bearing: this.map.getBearing()
            }

            localStorage.setItem('dashboardMapDefaults', JSON.stringify(data));

            Bus.$emit('flash-message', {
                message: 'Default map location / position recorded! We will use this for now as a default view'
            });
        },

        mapTypeChanged(type) {

            if (type === 0) {
                this.removeClusterLayers();
                this.createHeatMapLayers();
            }

            if (type === 1) {
                this.removeHeatMapLayers();
                this.createClusterLayers();
            }
        },

        mapSelected(item) {

            this.map.setBearing(0);
            this.map.setPitch(0);

            this.map.flyTo({
                center: item.coordinates,
                zoom: item.zoom,
                essential: true // this animation is considered essential with respect to prefers-reduced-motion
            });

            this.flying = item.spin;

            this.map.on('zoomend', () => {

                if (!this.flying) return;

                this.flying = false;

                if (item.bearing > 0) {

                    let bearing = 0;

                    const bearingInterval = setInterval(() => {
                        this.map.setBearing(bearing);
                        bearing++;

                        if (bearing >= item.bearing) {
                            clearInterval(bearingInterval);
                        }

                    }, 50);
                }
                //
                // // Spin around 360 degrees
                // if (item.bearing === 0 && item.pitch > 0) {
                //
                //     let bearing = 0;
                //
                //     const bearingInterval2 = setInterval(() => {
                //         bearing++;
                //         this.map.setBearing(bearing);
                //
                //         if (bearing >= 360) {
                //             clearInterval(bearingInterval2);
                //         }
                //
                //     }, 5)
                // }

                if (item.pitch > 0) {

                    let pitch = 0;

                    const pitchInterval = setInterval(() => {
                        this.map.setPitch(pitch);
                        pitch++;

                        if (pitch >= item.pitch) {
                            clearInterval(pitchInterval);
                        }

                    }, 5);
                }
            });
        },

        close() {
            this.$emit('close');
        },

        removeClusterLayers() {
            if (this.map.getLayer('clusters')) this.map.removeLayer('clusters');
            if (this.map.getLayer('cluster-count')) this.map.removeLayer('cluster-count');
            if (this.map.getLayer('markers')) this.map.removeLayer('markers');
        },

        createClusterLayers() {
            // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
            // with three steps to implement three types of circles:
            //   * Blue, 20px circles when point count is less than 100
            //   * Yellow, 30px circles when point count is between 100 and 750
            //   * Pink, 40px circles when point count is greater than or equal to 750
            this.map.addLayer({
                id: 'clusters',
                type: 'circle',
                source: 'clusters',
                filter: ['has', 'point_count'],
                paint: {

                    'circle-color': [
                        'step',
                        ['get', 'point_count'],
                        '#224f5a',
                        10,
                        '#2d6877',
                        50,
                        '#439ab0',
                        100,
                        '#4aabc3',
                    ],
                    'circle-radius': [
                        'step',
                        ['get', 'point_count'],
                        20, // size
                        10,
                        25,
                        50,
                        30,
                        100,
                        35
                    ]
                }
            });

            this.map.addLayer({
                id: 'cluster-count',
                type: 'symbol',
                source: 'clusters',
                filter: ['has', 'point_count'],
                layout: {
                    'text-field': '{point_count_abbreviated}',
                    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                    'text-size': 12,
                },
                paint: {
                    'text-color': 'white'
                }
            });

            // this.map.addLayer({
            //     id: 'unclustered-point',
            //     type: 'circle',
            //     source: 'clusters',
            //     filter: ['!', ['has', 'point_count']],
            //     paint: {
            //         'circle-color': '#2d6877',
            //         'circle-radius': 4,
            //         'circle-stroke-width': 1,
            //         'circle-stroke-color': '#fff',
            //     },
            // });
            //

            this.map.addLayer({
                id: 'markers',
                type: 'symbol',
                source: 'clusters',
                filter: ['!', ['has', 'point_count']],
                layout: {
                    'icon-image': 'marker',
                    'icon-size': 0.25,
                }
            });

            this.map.on('mouseenter', 'markers', () => {
                this.map.getCanvas().style.cursor = 'pointer'
            })
            this.map.on('mouseleave', 'markers', () => {
                this.map.getCanvas().style.cursor = ''
            })

            this.map.on('click', 'markers', (e) => {
                let features = this.map.queryRenderedFeatures(e.point);

                const panelistId = features[0].properties.id;

                this.$router.push('/spa/panelistmanager/edit/' + panelistId);
            });

            this.map.on('click', 'clusters', (e) => {
                let features = this.map.queryRenderedFeatures(e.point, {
                    layers: ['clusters']
                });
                let clusterId = features[0].properties.cluster_id;
                this.map.getSource('clusters').getClusterExpansionZoom(
                        clusterId,
                        (err, zoom) => {
                            if (err) return;

                            this.map.easeTo({
                                center: features[0].geometry.coordinates,
                                zoom: zoom
                            });
                        }
                );
            });
        },

        removeHeatMapLayers() {
            if (this.map.getLayer('heatmap')) this.map.removeLayer('heatmap');
            if (this.map.getLayer('points')) this.map.removeLayer('points');
        },

        createHeatMapLayers() {

            this.map.addLayer(
                    {
                        'id': 'heatmap',
                        'type': 'heatmap',
                        'source': 'locations',
                        'maxzoom': 15,
                        'paint': {
                            // increase weight as diameter breast height increases
                            'heatmap-weight': {
                                'property': 'dbh',
                                'type': 'exponential',
                                'stops': [
                                    [1, 0],
                                    [62, 1]
                                ]
                            },
                            // increase intensity as zoom level increases
                            'heatmap-intensity': {
                                'stops': [
                                    [11, 1],
                                    [15, 10]
                                ]
                            },
                            // use sequential color palette to use exponentially as the weight increases
                            'heatmap-color': [
                                'interpolate',
                                ['linear'],
                                ['heatmap-density'],
                                0,
                                'rgba(236,222,239,0)',
                                0.2,
                                'rgb(208,209,230)',
                                0.4,
                                'rgb(166,189,219)',
                                0.6,
                                'rgb(103,169,207)',
                                0.8,
                                'rgb(28,144,153)'
                            ],
                            // increase radius as zoom increases
                            'heatmap-radius': {
                                'stops': [
                                    [11, 15],
                                    [15, 20]
                                ]
                            },
                            // decrease opacity to transition into the circle layer
                            'heatmap-opacity': {
                                'default': 1,
                                'stops': [
                                    [14, 1],
                                    [15, 0]
                                ]
                            }
                        }
                    },
            );

            this.map.addLayer(
                    {
                        'id': 'points',
                        'type': 'circle',
                        'source': 'locations',
                        'minzoom': 8,
                        'paint': {
                            // increase the radius of the circle as the zoom level and dbh value increases
                            'circle-radius': {
                                'property': 'dbh',
                                'type': 'exponential',
                                'stops': [
                                    [{zoom: 15, value: 1}, 5],
                                    [{zoom: 15, value: 62}, 10],
                                    [{zoom: 22, value: 1}, 20],
                                    [{zoom: 22, value: 62}, 50]
                                ]
                            },
                            'circle-color': {
                                'property': 'dbh',
                                'type': 'exponential',
                                'stops': [
                                    [0, 'rgba(236,222,239,0)'],
                                    [10, 'rgb(236,222,239)'],
                                    [20, 'rgb(208,209,230)'],
                                    [30, 'rgb(166,189,219)'],
                                    [40, 'rgb(103,169,207)'],
                                    [50, 'rgb(28,144,153)'],
                                    [60, 'rgb(1,108,89)']
                                ]
                            },
                            'circle-stroke-color': 'white',
                            'circle-stroke-width': 1,
                            'circle-opacity': {
                                'stops': [
                                    [14, 0],
                                    [15, 1]
                                ]
                            }
                        }
                    });
        },

        loadData(force = false) {

            this.getProjectGeoStats({forceUpdate: force, projectId: this.project.id})
                    .then(geoStats => {

                        if (this.sourceAdded) {

                            this.removeHeatMapLayers();
                            this.removeClusterLayers();

                            this.map.removeSource('locations');
                            this.map.removeSource('clusters');
                        }

                        this.map.addSource('locations', {
                            type: 'geojson',
                            data: geoStats.data
                        });

                        this.map.addSource('clusters', {
                            type: 'geojson',
                            data: geoStats.data,
                            cluster: true,
                            clusterMaxZoom: 14, // Max zoom to cluster points on
                            clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
                        })

                        this.sourceAdded = true;

                        if (this.mapTypeModel === 0) {
                            this.createHeatMapLayers();
                        } else {
                            this.createClusterLayers();
                        }
                    })
                    .catch(error => {

                        console.log(error);

                        Bus.$emit('flash-message', {
                            type: 'error',
                            message: 'Geo coordinates failed to load! Try the reload button.'
                        });
                    });
        }
    }
}
</script>

<style scoped>

.wrapper {
    /* vuetify sets the v-tabs__container height to 48px */
    height: calc(100vh - 48px)
}
.floatingMenu {
    position: fixed;
    top: 60px;
    width: 400px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 4;
}

.floatingCompletesBox {
    position: fixed;
    bottom: 10px;
    width: 200px;
    left: 10px;
    z-index: 4;
}

.progress {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 1000;
}

.mapboxgl-canvas {
    position: absolute;
    width: 100%;
    height: calc(100% - 50px);
    margin: 0 0 0 0;
    padding: 0 0 0 0;
}

.mapbox-canvas-container {
    margin-bottom: 0;
    padding-bottom: 0;
}

.map {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    margin-bottom: 0;
    padding-bottom: 0;
}

.marker {
    background-size: cover;
    background-color: yellow;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
}

</style>
